// extracted by mini-css-extract-plugin
export default {"HomeMobile":"HomeMobile_HomeMobile__geOjw","WidgetsCarousel":"HomeMobile_WidgetsCarousel__De4ui"};